<!--
================================================
Un composant qui vérifie à interval régulier si l'user est toujours authentifié. Permet de mettre à jour l'UI si la session d'un user a expirée et évite ainsi qu'il intéragisse avec la pwa alors qu'il n'est plus authentifié.


Url d'accès :
http://localhost:8080/fr/cronocloud-inc/timeTracking
================================================
-->


<!------------------------------------------------
+++++++++++++++++++++ HTML +++++++++++++++++++++++
-------------------------------------------------->

<template>
    <div id="AuthCheckerComp"></div>
</template>

<!------------------------------------------------
+++++++++++++++++++ JAVASCRIPT++++++++++++++++++++
-------------------------------------------------->


<script>
    // import {mapState} from 'vuex'
    import SentryMixin from "../mixins/SentryMixin.js";
    import GlobalErrorNotification from "../mixins/GlobalErrorNotificationMixin.js";
    import InterceptorMixin from "../mixins/InterceptorMixin.js";

    export default {
        name: 'AuthCheckerComp', //utile dans vue dev tool
        mixins: [
            GlobalErrorNotification,
            SentryMixin,
            InterceptorMixin
        ],

        data: function () {
            return {
                locale : this.$route.params.locale,
                intervalToCheck:20000, // int le nombre en millisecondes de l'interval (ex : si vaut 60000 on vérifiera toutes les minutes si l'user est authentifié)
                compEnabled :false, // Un boolean indiquant si le composant doit-être exécuté (corrige un bug qui faisait que même après une déconnexion volontaire de l'utilisateur, ce composant continuait de s'exécuter : https://gitlab.com/ousmane1/kronocloud/-/issues/832)
            }
        },

        computed:{
        },


        methods: {


          isUserStillAuthenticated: function(){
            if(!this.$auth.isAuthenticated()){

              if(this.compEnabled){
              this.logToSentry(this, `🦋 Ui session expired redirected to login`, 'info')
              this.redirectExpiredUser()
              }
            }

          },

          /*
            Redirige l'utilisateur vers le formulaire de login avec un message indiquant l'expiration de la session.
           */
          redirectExpiredUser: function (){
            let self =this
            this.$store.commit('UpdateGlobalNotificationComp', {
              'isVisible': true,
              'color': 'is-warning',
              'message': self.$t('VotreSessionAExpirée')
            });
            this.$router.replace({name: 'logout', params: {locale:this.locale }})

          }


        },

        // LIFECYCLE HOOKS (https://v2.vuejs.org/v2/guide/instance.html#Lifecycle-Diagram)
        mounted: function () {

          this.compEnabled = true

          const self = this
          setInterval(function () {

            self.isUserStillAuthenticated()
          }, self.intervalToCheck);


        },

      destroyed: function () {

          // On marquel le composant comme désactivé lorsqu'il est détruit du dom
          this.compEnabled = false

      }
    }
</script>

<!------------------------------------------------
++++++++++++++++++++++ CSS +++++++++++++++++++++++
-------------------------------------------------->

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
    @import "../assets/css/globalVar.scss";
    /*@import "../assets/css/bulmaResponsiveDep.scss";*/

    #AuthCheckerComp{}
</style>
